import { IconButton, Box, Stack, Typography, Avatar } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Popper from '@mui/material/Popper';

import React, { useRef, useState } from "react";
import { getUserInfo } from "@/services/auth.ts";
import { CurrentUser } from "@/types/auth.ts";

import { removeToken } from "@/utils/functions.ts";
import { NavLink } from "react-router-dom";
import { grey } from "@mui/material/colors";

export default function User() {
    const matches = useMediaQuery('(min-width:600px)');

    const { data: user }: { data?: CurrentUser } = getUserInfo();
    const [open, setOpen] = useState<boolean>(false);

    const ref = useRef<any>(null);

    function handleLogout() {
        removeToken();
        window.location.href = '/auth/login'
    }

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    return user && (
        <Stack direction="row" justifyContent="end">
            <Box my="auto">
                {!matches ? (
                    <Avatar ref={ref} onClick={() => setOpen(!open)} alt={user.email}
                        sx={{ width: 24, height: 24, cursor: 'pointer' }} />
                ) : (
                    <Stack direction="row" sx={{ cursor: 'pointer' }} ref={ref} onClick={() => setOpen(!open)}>
                        <Typography fontSize={14} sx={{ my: 'auto' }}>{user?.email}</Typography>
                        <IconButton aria-label="account" size="small" sx={{ ml: 0.25 }}>
                            <ExpandMoreIcon />
                        </IconButton>
                    </Stack>
                )}
                {open && (
                    <Popper
                        open={true}
                        anchorEl={ref.current}
                        role={undefined}
                        transition
                        disablePortal
                    >
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Box sx={{
                                    bgcolor: 'white',
                                    boxShadow: '0 1px 1px 0 rgba(0, 28, 36, .3), 1px 1px 1px 0 rgba(0, 28, 36, .15), -1px 1px 1px 0 rgba(0, 28, 36, .15)',
                                }}>
                                    <ClickAwayListener onClickAway={() => setOpen(false)}>
                                        <MenuList id="account-menu" aria-labelledby="account-button"
                                            onKeyDown={handleListKeyDown}>
                                            <MenuItem component={NavLink} to="/account/information#profile"
                                                sx={{ color: grey[900], "&:hover": { color: grey[900] } }}
                                                onClick={() => setOpen(false)}>
                                                <Typography fontSize={14}>My account</Typography>
                                            </MenuItem>
                                            <MenuItem onClick={handleLogout}>
                                                <Typography fontSize={14}>Logout</Typography>
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Box>
                            </Grow>
                        )}
                    </Popper>
                )}
            </Box>
        </Stack>
    )
}